import { render } from "./BuilderHouseBorrowHeaderMobile.vue?vue&type=template&id=b8133476&scoped=true&ts=true&lang=pug"
import script from "./BuilderHouseBorrowHeaderMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderHouseBorrowHeaderMobile.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderHouseBorrowHeaderMobile.vue?vue&type=style&index=0&id=b8133476&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8133476"]])

export default __exports__